import { PaymentMethod } from '@stripe/stripe-js'
import { SubscriptionCard } from '@dtx-company/inter-app/src/api/subscription-service/types/models/SubscriptionServiceSubscription'

export function convertSubscriptionCardToPaymentMethod(
  subscriptionCard?: SubscriptionCard
): PaymentMethod {
  // This is not a perfect conversion but sets the necessary properties for
  // then displaying the payment method.
  return {
    card: subscriptionCard
      ? {
          brand: subscriptionCard.brand,
          last4: subscriptionCard.lastFour,
          wallet: {
            type: subscriptionCard.wallet
          },
          // not used but required:
          exp_month: Number(subscriptionCard?.expMonth) || 12,
          exp_year: Number(subscriptionCard?.expYear) || 2099,
          checks: null,
          funding: 'unknown',
          three_d_secure_usage: null,
          country: null
        }
      : undefined,

    // not used but required:
    id: '',
    billing_details: {
      address: null,
      email: null,
      name: subscriptionCard?.name || null,
      phone: null
    },
    created: new Date().getTime(),
    livemode: false,
    metadata: {},
    type: 'card',
    customer: null,
    object: 'payment_method'
  }
}
